/** HashRouter search param that records the in-app screen for Android/browser Back. */
export const APP_STEP_PARAM = 'rz';

/** Owned portfolio property id deep-link into Rentalyzer (cleared after apply). */
export const PROPERTY_ID_PARAM = 'propertyId';

export const KNOWN_APP_STEPS = new Set([
  'home',
  'form',
  'dashboard',
  'projectDocuments',
  'financementDossier',
  'scenario',
  'report',
  'amortization',
  'myFiles',
  'about',
  'clients',
  'checklists',
  'marketParams',
]);

export function getAppStepFromSearch(search) {
  const raw = typeof search === 'string' && search.startsWith('?') ? search.slice(1) : search || '';
  const step = new URLSearchParams(raw).get(APP_STEP_PARAM);
  if (!step || step === 'home') return 'home';
  return KNOWN_APP_STEPS.has(step) ? step : 'home';
}

/**
 * @param {string | null | undefined} search
 * @returns {string | null}
 */
export function getPropertyIdFromSearch(search) {
  const raw = typeof search === 'string' && search.startsWith('?') ? search.slice(1) : search || '';
  const value = new URLSearchParams(raw).get(PROPERTY_ID_PARAM);
  if (!value) return null;
  const trimmed = String(value).trim();
  return trimmed || null;
}

/** Keep share= / invitation= / etc. while writing the app step. */
export function searchWithAppStep(search, step) {
  const raw = typeof search === 'string' && search.startsWith('?') ? search.slice(1) : search || '';
  const params = new URLSearchParams(raw);
  if (!step || step === 'home') params.delete(APP_STEP_PARAM);
  else params.set(APP_STEP_PARAM, step);
  const next = params.toString();
  return next ? `?${next}` : '';
}

/**
 * Write app step and optional owned property id. Pass null/empty propertyId to clear it.
 * @param {string | null | undefined} search
 * @param {string} step
 * @param {string | null | undefined} propertyId
 */
export function searchWithAppStepAndProperty(search, step, propertyId) {
  const withStep = searchWithAppStep(search, step);
  const raw = withStep.startsWith('?') ? withStep.slice(1) : withStep || '';
  const params = new URLSearchParams(raw);
  const trimmed = propertyId == null ? '' : String(propertyId).trim();
  if (!trimmed) params.delete(PROPERTY_ID_PARAM);
  else params.set(PROPERTY_ID_PARAM, trimmed);
  const next = params.toString();
  return next ? `?${next}` : '';
}

/** Completing a screen should replace it so Back skips the finished form. */
export function shouldReplaceAppStep(prevStep, nextStep) {
  return (
    (prevStep === 'form' && nextStep === 'dashboard') ||
    (prevStep === 'scenario' && nextStep === 'report') ||
    (prevStep === 'report' && nextStep === 'scenario')
  );
}

/** In-app ← Retour target for the current screen. */
export function parentAppStep(step) {
  if (step === 'amortization') return 'report';
  if (
    step === 'form' ||
    step === 'projectDocuments' ||
    step === 'financementDossier' ||
    step === 'scenario' ||
    step === 'report'
  ) {
    return 'dashboard';
  }
  return 'home';
}

/** True when the in-app back control should move to `nextStep`. */
export function isAppStepBackTransition(prevStep, nextStep) {
  return parentAppStep(prevStep) === nextStep || (nextStep === 'home' && prevStep && prevStep !== 'home');
}
